export default __webpack_public_path__ + "static/media/x-circle.d7fdd5da.svg";